import header from '../base/header';
import analytics from '../../components/analytics/Analytics';
import Viewports from '../../components/fsUtils/Viewports';
import FsLazyLoad from '../../components/fsLazyLoad/FsLazyLoad';

let analyticsMeta = document.querySelector('[fs-prop="analytics"]');

if( analyticsMeta !== null && analyticsMeta.hasAttribute('utaglib-path') ) {
	analytics.sendPageView();
}

//fsLazyLoad
let fsLazyLoad = new FsLazyLoad();
fsLazyLoad.init();


// WEBPACK FOOTER //
// ./assets/layouts/partner/partner.js